export default __webpack_public_path__ + "db4c6ea565c0473a057d9b1cca74a10d.jpg";